module.exports = __webpack_public_path__ + "img/gymnastics.52794c09.svg";